import * as React from "react"
import { PermissionsDigest } from "@modules/graphql/types"
import { SiteSettingsSection } from "../constants"
import { Card, CardHeader } from "gatsby-interface"
import { RemoveSite } from "./RemoveSite"
import { TransferSite } from "./TransferSite"

export type DangerZoneProps = {
  siteId: string
  siteName: string
  permissions: PermissionsDigest
  organizationId: string
}

export function DangerZone({
  siteId,
  siteName,
  permissions,
  organizationId,
}: DangerZoneProps) {
  return (
    <Card id={SiteSettingsSection.Danger}>
      <CardHeader title="Danger Zone" />

      <TransferSite
        siteId={siteId}
        siteName={siteName}
        permissions={permissions}
        organizationId={organizationId}
      />

      <RemoveSite
        siteId={siteId}
        siteName={siteName}
        permissionToDelete={permissions?.sites?.delete}
      />
    </Card>
  )
}
